import { ButtonHTMLAttributes, ReactNode } from 'react'

interface CMButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'ghost' | 'muted' | 'danger'
  size?: 'sm' | 'md'
  children: ReactNode
}

const variantClasses = {
  primary: 'bg-primary-600 text-white font-medium hover:bg-primary-700 disabled:opacity-50',
  ghost: 'text-primary-600 hover:bg-primary-50 font-medium',
  muted: 'bg-gray-200 text-gray-900 hover:bg-gray-300',
  danger: 'bg-red-500 text-white hover:bg-red-600',
}

const sizeClasses = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-4 py-2 text-sm',
}

export const CMButton = ({ variant = 'primary', size = 'sm', children, className = '', ...rest }: CMButtonProps) => (
  <button
    className={`transition-all ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
    {...rest}
  >
    {children}
  </button>
)
